window.$ = window.jQuery = require('jquery')
window.Popper = require('popper.js')
require('slick-carousel');
import {$lightbox} from 'lightbox2';
require('lightbox2');

import 'jquery-match-height';

import './js/mdc-init.js'

import './js/form-validation.js'

import './js/main.js'